var Language;
(function (Language) {
    Language["ENGLISH"] = "en";
    Language["SLOVAK"] = "sk";
    // GERMAN = "de",
    Language["CZECH"] = "cs";
})(Language || (Language = {}));
export default Language;
